import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGraph = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.34668 12.9578V6.34625H10.6542V12.9578L9.50043 11.846L8.34668 12.9578ZM13.0197 14.823V2.34625H15.3272V12.5155L13.0197 14.823ZM3.65443 17.6193V10.3463H5.96193V15.3115L3.65443 17.6193ZM3.59668 20.8L9.46968 14.927L13.0197 17.977L19.1967 11.8H17.2504V10.3H21.7504V14.8H20.2504V12.8538L13.0812 20.023L9.53118 16.973L5.70418 20.8H3.59668Z",
		fill: "currentColor"
	})
});
export default SvgGraph;
